import React from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faSave,
  faTimes,
  faPen,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { Modal } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import { leaseDateFormat } from "../../utils/utils";
class MarketingFund extends React.Component {
  countError = "";
  state = {
    escalationIndex: 0,
    voucherTotalAmt: "",
    currentIndex: null,
    disableOnEdit: false,
    readOnEdit: false,
    applicableValue: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    to: "",
    showMfCapped: false,
    showAddBtn: false,
    isOpen: false,
    popupalertMessage: false,
    popupMessageContent: "",
    index_val: "",
    delete: false,
    revalue: "",
    showForm: false,
    fromDate: "",
    toDate: "",
    leaseTermDD: "",
    leaseTermMM: "",
    leaseTermYY: "",
    periodTermDD: "",
    periodTermMM: "",
    periodTermYY: "",
    renewalLeaseTermDD: "",
    renewalLeaseTermMM: "",
    renewalLeaseTermYY: "",
    period: 1,
    redirect: false,
    marketingFundDetails: [],
    marketingFundBasisRate: false,
    marketingFundBasisPureRevenueShare: false,
    marketingFundBasisPureRevenueShareSalesRange: false,
    marketingFundBasisPercentofRent: false,
    marketingFundBasisVouchers: false,
    initialValues: {
      mfLogic: {
        mfLogicText: "",
        period: "",
        fromDate: "",
        toDate: "",
        mfUom: "",
        mfDueDate: "",
        mfRate: "",
        mfRateTerm: "",
        onArea: "",
        mfFrequency: "",
        mfCapped: "",
        mfCappedOnArea: "",
        rentUom: "",
        rentRate: "",
        percentageofRent: "",
        voucherType: "",
        voucherTotalAmount: "",
        voucherAmount: "",
        voucherCount: "",
        voucherRate: "",
        mfLogicText: "",
        slabs: [],
      },
      totalSlabs: "",
    },
    toggleMfForm: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        countError: "Validation has failed!", // will override all messages
      },
    });

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  changeMfCapped(e) {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value == "yes") {
      this.setState({
        showMfCapped: true,
      });
    } else {
      this.setState({
        showMfCapped: false,
      });
    }
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  editMf(index, values) {
    this.state.currentIndex = index;
    this.state.disableOnEdit = true;
    this.state.readOnEdit = true;
    console.log(this.state.marketingFundDetails[index].voucherTotalAmount);
    this.state.period = this.state.marketingFundDetails[index].period;
    values.mfLogic.mfLogicText =
      this.state.marketingFundDetails[index].mfLogicText;
    this.state.initialValues.mfLogic.mfLogicText =
      this.state.marketingFundDetails[index].mfLogicText;
    this.state.initialValues.totalSlabs =
      this.state.marketingFundDetails[index].slabNumber;
    this.state.voucherTotalAmt =
      this.state.marketingFundDetails[index].voucherTotalAmount;
    this.setState({
      showForm: true,
      showAddBtn: true,
      periodTermDD: this.state.marketingFundDetails[index].periodTermDD,
      periodTermMM: this.state.marketingFundDetails[index].periodTermMM,
      periodTermYY: this.state.marketingFundDetails[index].periodTermYY,
    });
    if (
      this.state.marketingFundDetails[index].mfLogicText ===
      "Marketing Fund Basis Rate"
    ) {
      this.setState({
        marketingFundBasisRate: true,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (
      this.state.marketingFundDetails[index].mfLogicText ===
      "Marketing Fund Basis Pure Revenue Share"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: true,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (
      this.state.marketingFundDetails[index].mfLogicText ===
      "Marketing Fund Basis Pure Revenue Share Sales Range"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: true,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (
      this.state.marketingFundDetails[index].mfLogicText ===
      "Marketing Fund Basis % of Rent"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: true,
        marketingFundBasisVouchers: false,
      });
    } else if (
      this.state.marketingFundDetails[index].mfLogicText ===
      "Marketing Fund Basis Vouchers"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: true,
      });
    } else {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    }
    values.mfLogic = { ...this.state.marketingFundDetails[index] };
    this.state.fromDate = this.state.marketingFundDetails[index].fromDate;
    this.state.toDate = this.state.marketingFundDetails[index].toDate;

    if (this.state.marketingFundDetails[index].mfCapped == "Yes") {
      this.setState({ showMfCapped: true });
    } else {
      this.setState({ showMfCapped: false });
    }
    this.setState({});
  }

  addMfDetails = (values, resetForm, setFieldValue) => {
    if (this.state.currentIndex === null) {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }

      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      var _marketingFundDetails = this.state.marketingFundDetails;
      values.mfLogic.period = this.state.period;
      values.mfLogic.fromDate = this.state.fromDate;
      values.mfLogic.toDate = this.state.toDate;
      values.mfLogic.periodTermYY = this.state.periodTermYY;
      values.mfLogic.periodTermMM = this.state.periodTermMM;
      values.mfLogic.periodTermDD = this.state.periodTermDD;

      _marketingFundDetails.push(values.mfLogic);

      this.setState({
        marketingFundDetails: _marketingFundDetails,
        // marketingFundBasisRate: false,
        // marketingFundBasisPureRevenueShare: false,
        // marketingFundBasisPureRevenueShareSalesRange: false,
        // marketingFundBasisPercentofRent: false,
        // marketingFundBasisVouchers: false,
      });
      var _initialValues = this.state.initialValues;
      // _initialValues.mfLogic.mfLogicText = "";
      // this.state.initialValues.mfLogic.mfLogicText = "";
      this.setState({});
      _initialValues.mfLogic.slabs = [];
      _initialValues.totalSlabs = 0;

      this.setState({ initialValues: _initialValues });
      this.state.period++;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      // this.state.initialValues.mfLogic.mfLogicText = "";
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.marketingFundDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      setFieldValue("mfLogic.mfRate", "");
      setFieldValue("mfLogic.escalationPercent", "");
      this.setState({ isEdit: false, escalationIndex: this.state.period - 2 });
    } else {
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        return false;
      }

      if (this.state.toDate > values.to) {
        this.setState({
          popupalertMessage: true,
          popupMessageContent: "Enter a date less than " + values.to,
        });
        // alert("Enter a date less than " + values.to);
        return false;
      } else if (this.state.toDate == values.to) {
        this.state.showForm = false;
        this.state.showAddBtn = false;
      }
      // values.mfLogic.mfLogicText = this.state.initialValues.mfLogic.mfLogicText;
      var _marketingFundDetails = this.state.marketingFundDetails;
      values.mfLogic.period = this.state.period;
      values.mfLogic.fromDate = this.state.fromDate;
      values.mfLogic.toDate = this.state.toDate;
      values.mfLogic.periodTermYY = this.state.periodTermYY;
      values.mfLogic.periodTermMM = this.state.periodTermMM;
      values.mfLogic.periodTermDD = this.state.periodTermDD;

      _marketingFundDetails[this.state.currentIndex] = { ...values.mfLogic };

      this.setState({
        marketingFundDetails: _marketingFundDetails,
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
      var _initialValues = this.state.initialValues;
      // _initialValues.mfLogic.mfLogicText = "";
      // this.state.initialValues.mfLogic.mfLogicText = "";
      this.setState({});
      _initialValues.mfLogic.slabs = [];
      _initialValues.totalSlabs = 0;

      this.setState({ initialValues: _initialValues });
      this.state.period++;
      this.state.periodTermDD = 0;
      this.state.periodTermMM = 0;
      this.state.periodTermYY = 0;
      this.setState({
        fromDate: getToDate(this.state.toDate, 2, 0, 0),
        toDate: "",
      });
      if (this.state.marketingFundDetails.length > 0) {
        this.mainFormValidator.hideMessages();
      }
      resetForm();
      this.state.currentIndex = null;
      this.state.disableOnEdit = false;
      this.state.readOnEdit = false;
      this.state.initialValues.mfLogic.mfLogicText = "";
      this.setState({ isEdit: false, escalationIndex: this.state.period - 1 });
    }
  };

  resetMfDetails = (values, resetForm) => {
    this.setState({
      // marketingFundDetails: _marketingFundDetails,
      marketingFundBasisRate: false,
      marketingFundBasisPureRevenueShare: false,
      marketingFundBasisPureRevenueShareSalesRange: false,
      marketingFundBasisPercentofRent: false,
      marketingFundBasisVouchers: false,
    });
    var _initialValues = this.state.initialValues;
    // _initialValues.mfLogic.mfLogicText = "";
    // this.state.initialValues.mfLogic.mfLogicText = "";
    this.setState({});
    _initialValues.mfLogic.slabs = [];
    _initialValues.totalSlabs = 0;

    this.setState({ initialValues: _initialValues });
    this.state.period++;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;
    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });
    if (this.state.marketingFundDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }
    resetForm();
    this.state.currentIndex = null;
    this.state.disableOnEdit = false;
    this.state.readOnEdit = false;
    this.state.initialValues.mfLogic.mfLogicText = "";
    this.setState({});
  };


  handleReset = () => {
    this.setState({
      // marketingFundDetails: _marketingFundDetails,
      marketingFundBasisRate: false,
      marketingFundBasisPureRevenueShare: false,
      marketingFundBasisPureRevenueShareSalesRange: false,
      marketingFundBasisPercentofRent: false,
      marketingFundBasisVouchers: false,
    });
    var _initialValues = this.state.initialValues;
    // _initialValues.mfLogic.mfLogicText = "";
    // this.state.initialValues.mfLogic.mfLogicText = "";
    this.setState({});
    _initialValues.mfLogic.slabs = [];
    _initialValues.totalSlabs = 0;

    this.setState({ initialValues: _initialValues });
    this.state.period++;
    this.state.periodTermDD = 0;
    this.state.periodTermMM = 0;
    this.state.periodTermYY = 0;

    this.setState({
      fromDate: getToDate(this.state.toDate, 2, 0, 0),
      toDate: "",
    });

    if (this.state.marketingFundDetails.length > 0) {
      this.mainFormValidator.hideMessages();
    }

    this.state.currentIndex = null;
    this.state.disableOnEdit = false;
    this.state.readOnEdit = false;
    this.state.initialValues.mfLogic.mfLogicText = "";
    this.setState({});
  };

  addSlabRow = (e) => {
    this.state.initialValues.totalSlabs = e.target.value;
    if (this.state.initialValues.mfLogic.slabs.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.mfLogic.slabs.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.mfLogic.slabs.push({
          from: "",
          to: "",
          percent: "",
        });
      }
    } else if (this.state.initialValues.mfLogic.slabs.length > e.target.value) {
      var toRemove =
        this.state.initialValues.mfLogic.slabs.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.mfLogic.slabs.pop({});
      }
    }
  };

  getFromForNextSlab(e, values, index) {
    this.state.initialValues.mfLogic.slabs[index + 1].from =
      Number(e.target.value) + Number(1);
    this.setState({});
  }

  hadleMfLogicChange = (event) => {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (event.target.value === "") {
      this.state.showAddBtn = false;
    } else {
      this.state.showAddBtn = true;
    }
    var index = event.nativeEvent.target.selectedIndex;
    var text = event.nativeEvent.target[index].label;
    this.state.initialValues.mfLogic.mfLogicText = text;
    // this.state.initialValues.mfLogic.mfLogicValue = event.target.value;
    if (event.target.value === "Marketing Fund Basis Rate") {
      this.setState({
        marketingFundBasisRate: true,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (
      event.target.value === "Marketing Fund Basis Pure Revenue Share"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: true,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (
      event.target.value ===
      "Marketing Fund Basis Pure Revenue Share Sales Range"
    ) {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: true,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    } else if (event.target.value === "Marketing Fund Basis % of Rent") {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: true,
        marketingFundBasisVouchers: false,
      });
    } else if (event.target.value === "Marketing Fund Basis Vouchers") {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: true,
      });
    } else {
      this.setState({
        marketingFundBasisRate: false,
        marketingFundBasisPureRevenueShare: false,
        marketingFundBasisPureRevenueShareSalesRange: false,
        marketingFundBasisPercentofRent: false,
        marketingFundBasisVouchers: false,
      });
    }
  };

  componentDidMount() {

    let athis=this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-lease-marketing-fund-details?id=${this.props.match.params.id}`,
      method: 'GET'
    }).then(function (response){
      let data = response.data;
      athis.state.to = data.to;
      athis.state.fromDate = data.from;
      athis.state.applicableValue = data.marketingFundApplicable;
      athis.setState({});
      if (data.marketingFundDetails.length > 0) {
        // let _tempDate = new Date(
        //   data.marketingFundDetails[
        //     data.marketingFundDetails.length - 1
        //   ].toDate
        // );
        // _tempDate.setDate(_tempDate.getDate() + 1);
        // var dd = ("0" + _tempDate.getDate()).slice(-2);
        // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
        // var y = _tempDate.getFullYear();
        // var someFormattedDate = y + "-" + mm + "-" + dd;
        // athis.state.fromDate = someFormattedDate;
        athis.setState({
          fromDate: getToDate(
            data.marketingFundDetails[data.marketingFundDetails.length - 1]
              .toDate,
            2,
            0,
            0
          ),
        });
      }
      if (data.marketingFundApplicable === "yes") {
        athis.setState({
          toggleMfForm: true,
        });
      } else {
        athis.setState({
          toggleMfForm: false,
        });
      }
      athis.setState({
        initialValues: data,
        marketingFundDetails: data.marketingFundDetails,
        renewalLeaseTermDD: data.renewalLeaseTermDD,
        renewalLeaseTermMM: data.renewalLeaseTermMM,
        renewalLeaseTermYY: data.renewalLeaseTermYY,
        leaseTermDD: data.leaseTermDD,
        leaseTermMM: data.leaseTermMM,
        leaseTermYY: data.leaseTermYY,
        period:
          data.marketingFundDetails.length > 0
            ? data.marketingFundDetails.length + 1
            : 1,
      });

      if (
        data.marketingFundDetails.length > 0 &&
        data.marketingFundDetails[data.marketingFundDetails.length - 1]
          .toDate == data.to
      ) {
        athis.setState({
          showForm: false,
        });
      } else {
        athis.setState({
          showForm: true,
        });
      }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-marketing-fund-details?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.state.to = data.to;
    //     this.state.fromDate = data.from;
    //     this.state.applicableValue = data.marketingFundApplicable;
    //     this.setState({});
    //     if (data.marketingFundDetails.length > 0) {
    //       // let _tempDate = new Date(
    //       //   data.marketingFundDetails[
    //       //     data.marketingFundDetails.length - 1
    //       //   ].toDate
    //       // );
    //       // _tempDate.setDate(_tempDate.getDate() + 1);
    //       // var dd = ("0" + _tempDate.getDate()).slice(-2);
    //       // var mm = ("0" + (_tempDate.getMonth() + 1)).slice(-2);
    //       // var y = _tempDate.getFullYear();
    //       // var someFormattedDate = y + "-" + mm + "-" + dd;
    //       // this.state.fromDate = someFormattedDate;
    //       this.setState({
    //         fromDate: getToDate(
    //           data.marketingFundDetails[data.marketingFundDetails.length - 1]
    //             .toDate,
    //           2,
    //           0,
    //           0
    //         ),
    //       });
    //     }
    //     if (data.marketingFundApplicable === "yes") {
    //       this.setState({
    //         toggleMfForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleMfForm: false,
    //       });
    //     }
    //     this.setState({
    //       initialValues: data,
    //       marketingFundDetails: data.marketingFundDetails,
    //       renewalLeaseTermDD: data.renewalLeaseTermDD,
    //       renewalLeaseTermMM: data.renewalLeaseTermMM,
    //       renewalLeaseTermYY: data.renewalLeaseTermYY,
    //       leaseTermDD: data.leaseTermDD,
    //       leaseTermMM: data.leaseTermMM,
    //       leaseTermYY: data.leaseTermYY,
    //       period:
    //         data.marketingFundDetails.length > 0
    //           ? data.marketingFundDetails.length + 1
    //           : 1,
    //     });

    //     if (
    //       data.marketingFundDetails.length > 0 &&
    //       data.marketingFundDetails[data.marketingFundDetails.length - 1]
    //         .toDate == data.to
    //     ) {
    //       this.setState({
    //         showForm: false,
    //       });
    //     } else {
    //       this.setState({
    //         showForm: true,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  showMfForm = (e) => {
    if (e.target.value === "yes") {
      this.setState(
        {
          toggleMfForm: true,
        },
        () => {
          console.log(this.state.toggleMfForm);
        }
      );
    } else {
      this.setState({
        toggleMfForm: false,
      });
    }
  };

  calculateToDate() {
    this.setState({
      toDate: getToDate(
        this.state.fromDate,
        this.state.periodTermDD,
        this.state.periodTermMM,
        this.state.periodTermYY
      ),
    });
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToDelete = () => {
    var _mf = this.state.marketingFundDetails;
    _mf.splice(this.state.index_val, 1);
    console.log(_mf, "new array");
    this.setState({
      marketingFundDetails: _mf,
      showForm: true,
    });
    this.state.period--;
    if (this.state.marketingFundDetails.length > 0) {
      this.setState({
        fromDate: getToDate(
          this.state.marketingFundDetails[
            this.state.marketingFundDetails.length - 1
          ].toDate,
          2,
          0,
          0
        ),
      });
    } else {
      this.setState({
        fromDate: this.state.revalue,
      });
    }
    this.setState({
      delete: false,
      index_val: "",
      revalue: "",
    });
  };

  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  calculateRentRate(e, values, setFieldValue) {
    if (this.state.period > 1) {
      setFieldValue(
        "mfLogic.mfRate",
        (
          Number(
            this.state.marketingFundDetails[
              this.state.marketingFundDetails.length - 1
            ].mfRate
          ) *
          (1 + Number(e.target.value) / 100)
        ).toFixed(2)
      );
    }
  }

  calculateEscalationPercent(e, values, setFieldValue) {
    if (
      this.state.period > 1 &&
      this.state.marketingFundDetails[this.state.escalationIndex].mfRate !== 0
    ) {
      setFieldValue(
        "mfLogic.escalationPercent",
        (
          ((Number(e.target.value) -
            Number(
              this.state.marketingFundDetails[this.state.escalationIndex].mfRate
            )) /
            Number(
              this.state.marketingFundDetails[
                this.state.marketingFundDetails.length - 1
              ].mfRate
            )) *
          100
        ).toFixed(2)
      );
    }
  }

  calculateVoucherTotal(values, e, setFieldValue) {
    let amount;
    if (
      isNaN(values.mfLogic.voucherCount) !== "" &&
      isNaN(values.mfLogic.voucherAmount) !== ""
    ) {
      amount =
        Number(values.mfLogic.voucherCount) *
        Number(values.mfLogic.voucherAmount);
      this.setState({ voucherTotalAmt: amount });
      setFieldValue("mfLogic.voucherTotalAmount", amount);
    } else {
      amount = "";
      this.setState({ voucherTotalAmt: amount });
      setFieldValue("mfLogic.voucherTotalAmount", amount);
    }
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={
            "/createlease/property-muncipal-tax-fund/" +
            this.props.match.params.id
          }
        />
      );
    }
    return (
      <div className="parentContainer createLease">
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Other Charges</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Marketing Fund</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                values.marketingFundApplicable = this.state.applicableValue;
                values.mfLogic.voucherTotalAmount = this.state.voucherTotalAmt;
                if (!this.applicableValidator.allValid()) {
                  this.applicableValidator.showMessages();
                  return false;
                }
                if (
                  this.state.marketingFundDetails.length == 0 &&
                  this.state.applicableValue !== "no"
                ) {
                  this.mainFormValidator.showMessages("countError");
                  return false;
                }
                // if (
                //   this.state.applicableValue == "yes" &&
                //   this.state.to !==
                //     this.state.marketingFundDetails[
                //       this.state.marketingFundDetails.length - 1
                //     ].toDate
                // ) {
                //   // alert("Please Complete the period ");
                //   this.setState({
                //     popupalertMessage: true,
                //     popupMessageContent: "Please Complete the period",
                //   });
                //   return false;
                // }
                values.marketingFundDetails = this.state.marketingFundDetails;

                console.log(values, "sending");
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-lease-marketing-fund-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off">
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Lease Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Lease Renewal Term (YY-MM-DD) <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <div className="row m-0">
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-4">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-4 p-0">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />
                                </div>
                              </div>
                              <ErrorMessage
                                name="leaseRenewalTerm"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>From</label>
                            <div className="position-relative">
                              <Field type="date" name="from" />
                              <ErrorMessage
                                name="from"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>To</label>
                            <div className="position-relative">
                              <Field type="date" name="to" />
                              <ErrorMessage
                                name="to"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Marketing Fund Applicable <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as="select"
                                name="marketingFundApplicable"
                                value={this.state.applicableValue}
                                onChange={(e) => {
                                  this.state.applicableValue = e.target.value;
                                  this.showMfForm(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="yes" label="Yes" />
                                <option value="no" label="No" />
                              </Field>
                              {this.applicableValidator.message(
                                "Marketing Fund Applicable",
                                this.state.applicableValue,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          {this.state.toggleMfForm && (
                            <>
                              {this.state.showForm && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>Period</label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        disabled={this.state.disableOnEdit}
                                        name="mfLogic.period"
                                        value={this.state.period}
                                        onChange={(e) => {
                                          this.state.period = e.target.value;
                                        }}
                                      />
                                      <ErrorMessage
                                        name="mfLogic.period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>Period Term</label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-4 p-0">

                                          <Field
                                            type="text"
                                            name="mfLogic.periodTermYY"
                                            placeholder="YY"
                                            className="centerPlaceHolder text-center"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermYY}
                                            onChange={(e) => {
                                              this.state.periodTermYY = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />
                                        </div>
                                        <div className="col-sm-4">
                                          <Field
                                            type="text"
                                            name="mfLogic.periodTermMM"
                                            placeholder="MM"
                                            className="centerPlaceHolder text-center"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermMM}
                                            onChange={(e) => {
                                              this.state.periodTermMM = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-4 p-0">
                                          <Field
                                            type="text"
                                            name="mfLogic.periodTermDD"
                                            placeholder="DD"
                                            className="centerPlaceHolder text-center"
                                            disabled={this.state.disableOnEdit}
                                            value={this.state.periodTermDD}
                                            onChange={(e) => {
                                              this.state.periodTermDD = e.target.value;
                                              handleChange(e);
                                            }}
                                            onBlur={(e) => {
                                              this.calculateToDate(e);
                                            }}
                                          />

                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="mfLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>

                                  <div className="gridColOneByThree">
                                    <div className="newGridSectionInner newGridSectionInnerForLogin">
                                      <label>
                                        Marketing Fund Logic{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <select
                                          name={"mfLogic.mfLogicText"}
                                          value={
                                            this.state.initialValues.mfLogic
                                              .mfLogicText
                                          }
                                          onChange={(e) => {
                                            handleChange(e);
                                            this.hadleMfLogicChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Marketing Fund Basis Rate"
                                            label="Marketing Fund Basis Rate"
                                          />
                                          <option
                                            value="Marketing Fund Basis Pure Revenue Share"
                                            label="Marketing Fund Basis Pure Revenue Share"
                                          />
                                          <option
                                            value="Marketing Fund Basis Pure Revenue Share Sales Range"
                                            label="Marketing Fund Basis Pure Revenue Share Sales Range"
                                          />
                                          <option
                                            value="Marketing Fund Basis % of Rent"
                                            label="Marketing Fund Basis % of Rent"
                                          />
                                          <option
                                            value="Marketing Fund Basis Vouchers"
                                            label="Marketing Fund Basis Vouchers"
                                          />
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}

                              {this.state.marketingFundBasisRate && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={true}
                                        name="mfLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        readOnly={true}
                                        name="mfLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"mfLogic.mfUom"}
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({
                                            autoForceUpdate: this,
                                          });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "Mf UOM",
                                        values.mfLogic.mfUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {values.mfLogic.mfUom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"mfLogic.onArea"}
                                          onChange={(e) => {
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.mfLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  {this.state.period > 1 &&
                                    typeof this.state.marketingFundDetails[this.state.escalationIndex].mfRate !== "undefined" &&
                                    this.state.marketingFundDetails[this.state.escalationIndex].mfRate !== 0 && (
                                      <div className="newGridSectionInner">
                                        <label>
                                          Escalation %
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="mfLogic.escalationPercent"
                                            disabled={this.state.disableOnEdit}
                                            onBlur={(e) => {
                                              this.calculateRentRate(e, values, setFieldValue);
                                            }}
                                          />
                                          {this.validator.message(
                                            "Escalation %",
                                            values.mfLogic.escalationPercent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Rate <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="mfLogic.mfRate"
                                        onBlur={(e) => {
                                          this.calculateEscalationPercent(e, values, setFieldValue);
                                        }}
                                      />
                                      {this.validator.message(
                                        "MF Rate",
                                        values.mfLogic.mfRate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"mfLogic.mfRateTerm"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Rate Term",
                                        values.mfLogic.mfRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"mfLogic.mfFrequency"}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Frequency",
                                        values.mfLogic.mfFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueDate"
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueType"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueFrequency"
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.mfLogic.mfDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}

                              {this.state.marketingFundBasisPureRevenueShare && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Revenue Share (%) <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        name="mfLogic.revenueShare"
                                        type="number"
                                      />
                                      {this.validator.message(
                                        "Revenue Share",
                                        values.mfLogic.revenueShare,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfRateTerm"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Rate Term",
                                        values.mfLogic.mfRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfFrequency"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Frequency",
                                        values.mfLogic.mfFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="mfLogic.mfDueDate"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">

                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueType"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>
                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueFrequency"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.mfLogic.mfDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Capped
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name={"mfLogic.mfCapped"}
                                        onChange={(e) => {
                                          this.changeMfCapped(e);
                                          handleChange(e);
                                        }}
                                      >
                                        <option
                                          value=""
                                          label="Select"
                                          defaultValue
                                        />
                                        <option value="yes" label="Yes" />
                                        <option value="no" label="No" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Capped",
                                        values.mfLogic.mfCapped,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {this.state.showMfCapped && (
                                    <>
                                      <div className="newGridSectionInner">
                                        <label>
                                          MF Capped UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfCappedUom"
                                            onChange={(e) => {
                                              this.validator = new SimpleReactValidator({
                                                autoForceUpdate: this,
                                              });
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Per Sq Ft" label="Per Sq Ft" />
                                            <option value="Flat Amount" label="Flat Amount" />
                                          </Field>
                                          {this.validator.message(
                                            "MF Capped Uom",
                                            values.mfLogic.mfCappedUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      {values.mfLogic.mfCappedUom === "Per Sq Ft" && (
                                        <div className="newGridSectionInner">
                                          <label>
                                            MF Capped on Area <span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="mfLogic.mfCappedOnArea"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Usable Area" label="Usable Area" />
                                              <option value="Carpet Area" label="Carpet Area" />
                                              <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped on Area",
                                              values.mfLogic.mfCappedOnArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div className="newGridSectionInner">
                                        <label>
                                          MF Capped Rate <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            type="number"
                                            name="mfLogic.mfCappedRate"
                                          />
                                          {this.validator.message(
                                            "MF Capped Rate",
                                            values.mfLogic.mfCappedRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>

                                      <div className="newGridSectionInner">
                                        <label>
                                          MF Capped Rate Term <span className="astrik">*</span>
                                        </label>
                                        <div className="position-relative">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfCappedRateTerm"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Daily" label="Daily" />
                                            <option value="Monthly" label="Monthly" />
                                            <option value="Quarterly" label="Quarterly" />
                                            <option value="Half Yearly" label="Half Yearly" />
                                            <option value="Yearly" label="Yearly" />
                                          </Field>
                                          {this.validator.message(
                                            "MF Capped Rate Term",
                                            values.mfLogic.mfCappedRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}

                              {this.state
                                .marketingFundBasisPureRevenueShareSalesRange && (
                                  <>
                                    <div className="newGridSectionInner">
                                      <label>Revenue Share (%)</label>
                                    </div>
                                    <div className="newGridSectionInner">
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>
                                        No. of SLABS<span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          type="text"
                                          name="mfLogic.slabNumber"
                                          value={this.state.initialValues.totalSlabs}
                                          className="slabInput"
                                          onChange={(e) => {
                                            this.addSlabRow(e);
                                            handleChange(e);
                                          }}
                                        />
                                        <ErrorMessage
                                          name="mfLogic.slabNumber"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                    <div className="gridColOneByThree">
                                      <table className="tableSimple w-100">
                                        <thead>
                                          <tr>
                                            <th>SLAB</th>
                                            <th>FROM</th>
                                            <th>To</th>
                                            <th>MF Revenue Share (%)</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.initialValues.mfLogic.slabs.length > 0 &&
                                            this.state.initialValues.mfLogic.slabs.map(
                                              (slab, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`mfLogic.slabs.${index}.from`}
                                                      value={slab.from}
                                                      onChange={(e) => {
                                                        this.state.initialValues.mfLogic.slabs[index].from = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`mfLogic.slabs.${index}.to`}
                                                      value={slab.to}
                                                      onChange={(e) => {
                                                        this.state.initialValues.mfLogic.slabs[index].to = e.target.value;
                                                        handleChange(e);
                                                      }}
                                                      onBlur={(e) => {
                                                        if (index < this.state.initialValues.mfLogic.slabs.length - 1) {
                                                          this.getFromForNextSlab(e, values, index);
                                                        }
                                                      }}
                                                    />
                                                  </td>
                                                  <td>
                                                    <Field
                                                      type="text"
                                                      name={`mfLogic.slabs.${index}.percent`}
                                                    />
                                                  </td>
                                                  <td>
                                                    <a
                                                      className="actionDelete"
                                                      href="#"
                                                      onClick={(e) => {
                                                        this.state.initialValues.totalSlabs--;
                                                        var _slabs = this.state.initialValues.mfLogic.slabs;
                                                        _slabs.splice(index, 1);
                                                        this.setState({ slabs: _slabs });
                                                      }}
                                                    >
                                                      <FontAwesomeIcon icon={faTimes} />
                                                    </a>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>From</label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="mfLogic.fromDate"
                                          value={this.state.fromDate}
                                          onChange={(e) => handleChange(e)}
                                        />
                                        {this.validator.message(
                                          "From",
                                          this.state.fromDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>To</label>
                                      <div className="position-relative">
                                        <Field
                                          type="date"
                                          name="mfLogic.toDate"
                                          value={this.state.toDate}
                                          onChange={(e) => handleChange(e)}
                                        />
                                        {this.validator.message(
                                          "To",
                                          this.state.toDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>MF Rate Term</label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="mfLogic.mfRateTerm"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Per Month" label="Per Month" />
                                          <option value="Per Quarter" label="Per Quarter" />
                                          <option value="Per Half Year" label="Per Half Year" />
                                          <option value="Per Year" label="Per Year" />
                                          <option value="Per Day" label="Per Day" />
                                        </Field>
                                        {this.validator.message(
                                          "MF Rate Term",
                                          values.mfLogic.mfRateTerm,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>MF Frequency</label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="mfLogic.mfFrequency"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Daily" label="Daily" />
                                          <option value="Monthly" label="Monthly" />
                                          <option value="Quarterly" label="Quarterly" />
                                          <option value="Half Yearly" label="Half Yearly" />
                                          <option value="Yearly" label="Yearly" />
                                        </Field>
                                        {this.validator.message(
                                          "MF Frequency",
                                          values.mfLogic.mfFrequency,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>MF Due Date</label>
                                      <div className="position-relative">
                                        <div className="row m-0">
                                          <div className="col-sm-6 ps-0">

                                            <Field
                                              type="number"
                                              name="mfLogic.mfDueDate"
                                              onChange={(e) => handleChange(e)}
                                            />
                                          </div>
                                          <div className="col-sm-6 pe-0">
                                            <Field
                                              as="select"
                                              name="mfLogic.mfDueType"
                                              onChange={(e) => handleChange(e)}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Date" label="Date" />
                                              <option value="Days" label="Days" />
                                              <option value="Working Day" label="Working Day" />
                                            </Field>

                                          </div>
                                          <div className="col-sm-12 p-0 mt-3">
                                            <Field
                                              as="select"
                                              name="mfLogic.mfDueFrequency"
                                              onChange={(e) => handleChange(e)}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Every Month" label="Every Month" />
                                              <option value="Subsequent Month" label="Subsequent Month" />
                                              <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                              <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                              <option value="Subsequent Year" label="Subsequent Year" />
                                              <option value="Next Financial Year" label="Next Financial Year" />
                                            </Field>

                                          </div>
                                        </div>
                                        {this.validator.message(
                                          "Due Date",
                                          values.mfLogic.mfDueDate,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                    <div className="newGridSectionInner">
                                      <label>
                                        MF Capped
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name={"mfLogic.mfCapped"}
                                          onChange={(e) => {
                                            this.changeMfCapped(e);
                                            handleChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option value="yes" label="Yes" />
                                          <option value="no" label="No" />
                                        </Field>
                                        {this.validator.message(
                                          "MF Capped",
                                          values.mfLogic.mfCapped,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>

                                    {this.state.showMfCapped && (
                                      <>
                                        <div className="newGridSectionInner">
                                          <label>
                                            MF Capped UOM<span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="mfLogic.mfCappedUom"
                                              onChange={(e) => {
                                                this.validator = new SimpleReactValidator({ autoForceUpdate: this });
                                                handleChange(e);
                                              }}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Per Sq Ft" label="Per Sq Ft" />
                                              <option value="Flat Amount" label="Flat Amount" />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped Uom",
                                              values.mfLogic.mfCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>

                                        {values.mfLogic.mfCappedUom === "Per Sq Ft" && (
                                          <div className="newGridSectionInner">
                                            <label>
                                              MF Capped on Area<span className="astrik">*</span>
                                            </label>
                                            <div className="position-relative">
                                              <Field
                                                as="select"
                                                name="mfLogic.mfCappedOnArea"
                                                onChange={(e) => handleChange(e)}
                                              >
                                                <option value="" label="Select" defaultValue />
                                                <option value="Usable Area" label="Usable Area" />
                                                <option value="Carpet Area" label="Carpet Area" />
                                                <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                              </Field>
                                              {this.validator.message(
                                                "MF Capped on Area",
                                                values.mfLogic.mfCappedOnArea,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        )}

                                        <div className="newGridSectionInner">
                                          <label>
                                            MF Capped Rate<span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field type="number" name="mfLogic.mfCappedRate" />
                                            {this.validator.message(
                                              "MF Capped Rate",
                                              values.mfLogic.mfCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>

                                        <div className="newGridSectionInner">
                                          <label>
                                            MF Capped Rate Term<span className="astrik">*</span>
                                          </label>
                                          <div className="position-relative">
                                            <Field
                                              as="select"
                                              name="mfLogic.mfCappedRateTerm"
                                              onChange={(e) => handleChange(e)}
                                            >
                                              <option value="" label="Select" defaultValue />
                                              <option value="Daily" label="Daily" />
                                              <option value="Monthly" label="Monthly" />
                                              <option value="Quarterly" label="Quarterly" />
                                              <option value="Half Yearly" label="Half Yearly" />
                                              <option value="Yearly" label="Yearly" />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped Rate Term",
                                              values.mfLogic.mfCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                              {this.state.marketingFundBasisPercentofRent && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Rent UOM <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfUom"
                                        onChange={(e) => {
                                          this.validator = new SimpleReactValidator({ autoForceUpdate: this });
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Sq Ft" label="Per Sq Ft" />
                                        <option value="Flat Amount" label="Flat Amount" />
                                      </Field>
                                      {this.validator.message(
                                        "Rent UOM",
                                        values.mfLogic.mfUom,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  {values.mfLogic.mfUom === "Per Sq Ft" && (
                                    <div className="newGridSectionInner">
                                      <label>
                                        On Area
                                      </label>
                                      <div className="position-relative">
                                        <Field
                                          as="select"
                                          name="mfLogic.onArea"
                                          onChange={(e) => handleChange(e)}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          <option value="Usable Area" label="Usable Area" />
                                          <option value="Carpet Area" label="Carpet Area" />
                                          <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                        </Field>
                                        {this.validator.message(
                                          "On Area",
                                          values.mfLogic.onArea,
                                          "required",
                                          { className: "text-danger" }
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="newGridSectionInner">
                                    <label>
                                      Rent Rate <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="mfLogic.rentRate"
                                      />
                                      {this.validator.message(
                                        "Rent Rate",
                                        values.mfLogic.rentRate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Percentage of Rent <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="mfLogic.percentageofRent"
                                      />
                                      {this.validator.message(
                                        "Percentage of Rent",
                                        values.mfLogic.percentageofRent,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfRateTerm"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Rate Term",
                                        values.mfLogic.mfRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfFrequency"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Frequency",
                                        values.mfLogic.mfFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="mfLogic.mfDueDate"
                                            onChange={(e) => handleChange(e)}
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueType"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueFrequency"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.mfLogic.mfDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}

                              {this.state.marketingFundBasisVouchers && (
                                <>
                                  <div className="newGridSectionInner">
                                    <label>
                                      From <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.fromDate"
                                        value={this.state.fromDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "From",
                                        this.state.fromDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      To <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="date"
                                        name="mfLogic.toDate"
                                        value={this.state.toDate}
                                        onChange={(e) => handleChange(e)}
                                      />
                                      {this.validator.message(
                                        "To",
                                        this.state.toDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Rate Term <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfRateTerm"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Per Month" label="Per Month" />
                                        <option value="Per Quarter" label="Per Quarter" />
                                        <option value="Per Half Year" label="Per Half Year" />
                                        <option value="Per Year" label="Per Year" />
                                        <option value="Per Day" label="Per Day" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Rate Term",
                                        values.mfLogic.mfRateTerm,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Type of Vouchers <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.voucherType"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="value" label="Value" />
                                        <option value="conditional" label="Conditional" />
                                        <option value="unconditional" label="Unconditional" />
                                      </Field>
                                      {this.validator.message(
                                        "Type of Vouchers",
                                        values.mfLogic.voucherType,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Amount Per Voucher <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="mfLogic.voucherAmount"
                                        onBlur={(e) => this.calculateVoucherTotal(values, e, setFieldValue)}
                                      />
                                      {this.validator.message(
                                        "Voucher Amount",
                                        values.mfLogic.voucherAmount,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Voucher Count <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="text"
                                        name="mfLogic.voucherCount"
                                        onBlur={(e) => this.calculateVoucherTotal(values, e, setFieldValue)}
                                      />
                                      {this.validator.message(
                                        "Count",
                                        values.mfLogic.voucherCount,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      Total Amount of Vouchers <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        type="number"
                                        name="mfLogic.voucherTotalAmount"
                                        value={this.state.voucherTotalAmt}
                                        onChange={handleChange}
                                      />
                                      {this.validator.message(
                                        "Voucher Amount",
                                        this.state.voucherTotalAmt,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Frequency <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <Field
                                        as="select"
                                        name="mfLogic.mfFrequency"
                                        onChange={(e) => handleChange(e)}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        <option value="Daily" label="Daily" />
                                        <option value="Monthly" label="Monthly" />
                                        <option value="Quarterly" label="Quarterly" />
                                        <option value="Half Yearly" label="Half Yearly" />
                                        <option value="Yearly" label="Yearly" />
                                      </Field>
                                      {this.validator.message(
                                        "MF Frequency",
                                        values.mfLogic.mfFrequency,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>

                                  <div className="newGridSectionInner">
                                    <label>
                                      MF Due Date <span className="astrik">*</span>
                                    </label>
                                    <div className="position-relative">
                                      <div className="row m-0">
                                        <div className="col-sm-6 ps-0">
                                          <Field
                                            type="number"
                                            name="mfLogic.mfDueDate"
                                            onChange={(e) => handleChange(e)}
                                          />

                                        </div>
                                        <div className="col-sm-6 pe-0">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueType"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option value="Working Day" label="Working Day" />
                                          </Field>

                                        </div>
                                        <div className="col-sm-12 p-0 mt-3">
                                          <Field
                                            as="select"
                                            name="mfLogic.mfDueFrequency"
                                            onChange={(e) => handleChange(e)}
                                          >
                                            <option value="" label="Select" defaultValue />
                                            <option value="Every Month" label="Every Month" />
                                            <option value="Subsequent Month" label="Subsequent Month" />
                                            <option value="Subsequent Quarter" label="Subsequent Quarter" />
                                            <option value="Subsequent Half Year" label="Subsequent Half Year" />
                                            <option value="Subsequent Year" label="Subsequent Year" />
                                            <option value="Next Financial Year" label="Next Financial Year" />
                                          </Field>

                                        </div>
                                      </div>
                                      {this.validator.message(
                                        "Due Date",
                                        values.mfLogic.mfDueDate,
                                        "required",
                                        { className: "text-danger" }
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                          <div className="gridColOneByThree">
                            <span className="remarks">Notes/Remarks</span>
                            <Field as="textarea" className="notes mb-3" name="notes_8" />
                          </div>

                        </div>
                        {this.state.showAddBtn && (
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button
                              className="add_button"
                              type="button"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.addMfDetails(
                                  values,
                                  resetForm,
                                  setFieldValue
                                );
                              }}
                            >
                              Add
                            </button>
                            <button
                              className="reset_button"
                              type="reset"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.resetMfDetails(values, resetForm);
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        )}
                        {this.mainFormValidator.message(
                          "Marketing Fund Details",
                          this.countError,
                          "required",
                          { className: "text-danger" }
                        )}
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Period</th>
                                <th scope="col">Period Term (YY-MM-DD)</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Marketing Fund Logic</th>
                                <th scope="col">Rate/ Flat Amount</th>
                                <th scope="col" colSpan="2">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.marketingFundDetails.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <tr key={"mfTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="popupLink"
                                        onClick={(e) => {
                                          this.state.popupData = name;
                                          this.openModal();
                                        }}
                                      >
                                        {name.period}
                                      </a>
                                    </td>
                                    <td>
                                      {name.periodTermYY == ""
                                        ? "0"
                                        : name.periodTermYY}
                                      {"-"}
                                      {name.periodTermMM == ""
                                        ? "0"
                                        : name.periodTermMM}
                                      {"-"}
                                      {name.periodTermDD == ""
                                        ? "0"
                                        : name.periodTermDD}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.fromDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.fromDate)}
                                    </td>
                                    <td>
                                      {/* {dateFormat(name.toDate, "dd mmm yyyy")} */}
                                      {leaseDateFormat(name.toDate)}
                                    </td>
                                    <td>{name.mfLogicText}</td>
                                    <td>
                                      {name.voucherAmount || name.mfRate || "-"}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="tableActionEdit rentalEdit"
                                        onClick={(e) => {
                                          this.editMf(index, values);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPen} />
                                      </button>
                                      {this.state.marketingFundDetails.length ==
                                        index + 1 && (
                                          <button
                                            type="button"
                                            className="actionDelete rentalDeleteButton"
                                            onClick={(e) => {
                                              // if (
                                              //   window.confirm(
                                              //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                              //   )
                                              // ) {
                                              //   var _mf =
                                              //     this.state.marketingFundDetails;
                                              //   _mf.splice(index, 1);
                                              //   console.log(_mf, "new array");
                                              //   this.setState({
                                              //     marketingFundDetails: _mf,
                                              //     showForm: true,
                                              //   });
                                              //   this.state.period--;
                                              //   if (
                                              //     this.state.marketingFundDetails
                                              //       .length > 0
                                              //   ) {
                                              //     this.setState({
                                              //       fromDate: getToDate(
                                              //         this.state
                                              //           .marketingFundDetails[
                                              //           this.state
                                              //             .marketingFundDetails
                                              //             .length - 1
                                              //         ].toDate,
                                              //         2,
                                              //         0,
                                              //         0
                                              //       ),
                                              //     });
                                              //   } else {
                                              //     this.setState({
                                              //       fromDate: values.from,
                                              //     });
                                              //   }
                                              // }
                                              this.handleReset()

                                              this.setState({
                                                delete: true,
                                                index_val: index,
                                                revalue: values.from,
                                              });
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                );
                              },
                                this)}
                            </tbody>
                          </table>
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button">
                              Save Draft
                            </button>
                            <button type="reset" className="reset_button">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>

                      </div>
                    </Form>
                  </div>


                  {/* <Form className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="unitFormContainerNew leaseSection">
                        <div className="row m-0">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.leaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lease Renewal Term (YY-MM-DD){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-3 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermYY}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermMM}
                                  />
                                </div>
                                <div className="col-sm-2 leaseTermFieldWidth">
                                  <Field
                                    type="text"
                                    name="leaseRenewalTermDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder text-center"
                                    value={this.state.renewalLeaseTermDD}
                                  />
                                </div>
                                <ErrorMessage
                                  name="leaseRenewalTerm"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row m-0">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  From
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="from" />
                                  <ErrorMessage
                                    name="from"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  To
                                </label>
                                <div className="col-sm-7">
                                  <Field type="date" name="to" />
                                  <ErrorMessage
                                    name="to"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Marketing Fund Applicable{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    as="select"
                                    name={"marketingFundApplicable"}
                                    value={this.state.applicableValue}
                                    onChange={(e) => {
                                      this.state.applicableValue = e.target.value;
                                      this.showMfForm(e);
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option value="yes" label="Yes" />
                                    <option value="no" label="No" />
                                  </Field>
                                  {this.applicableValidator.message(
                                    "Marketing Fund Applicable",
                                    this.state.applicableValue,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {this.state.toggleMfForm && (
                          <div className="mfApplicable">
                            <div className="row m-0">
                              {this.state.showForm && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period
                                      </label>
                                      <div className="col-sm-7">
                                        <Field
                                          type="text"
                                          disabled={this.state.disableOnEdit}
                                          name="mfLogic.period"
                                          value={this.state.period}
                                          onChange={(e) => {
                                            this.state.period = e.target.value;
                                          }}
                                        />
                                        <ErrorMessage
                                          name="mfLogic.period"
                                          component="div"
                                          className="text-red"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {this.state.showForm && (
                                <div className="col-lg-6">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-4 col-form-label">
                                        Period Term
                                      </label>
                                      <div className="col-sm-3 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="mfLogic.periodTermmYY"
                                          placeholder="YY"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermYY}
                                          onChange={(e) => {
                                            this.state.periodTermYY =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="mfLogic.periodTermMM"
                                          placeholder="MM"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermMM}
                                          onChange={(e) => {
                                            this.state.periodTermMM =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-2 leaseTermFieldWidth">
                                        <Field
                                          type="text"
                                          name="mfLogic.periodTermDD"
                                          placeholder="DD"
                                          className="centerPlaceHolder text-center"
                                          disabled={this.state.disableOnEdit}
                                          value={this.state.periodTermDD}
                                          onChange={(e) => {
                                            this.state.periodTermDD =
                                              e.target.value;
                                            handleChange(e);
                                          }}
                                          onBlur={(e) => {
                                            this.calculateToDate(e);
                                          }}
                                        />
                                      </div>
                                      <ErrorMessage
                                        name="mfLogic.periodTerm"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>


                            {this.state.showForm && (
                              <div className="row m-0">
                                <div className="col-lg-12">
                                  <div className="inputContainer col-lg-12 col-md-12">
                                    <div className="row mb-3">
                                      <label className="col-sm-2 col-form-label">
                                        Marketing Fund Logic{" "}
                                        <span className="astrik">*</span>
                                      </label>
                                      <div className="col-sm-10 logicDropdownWidthDesktop">
                                        <select
                                          name={"mfLogic.mfLogicText"}
                                          // disabled={this.state.disableOnEdit}
                                          value={
                                            this.state.initialValues.mfLogic
                                              .mfLogicText
                                          }
                                          onChange={(e) => {
                                            handleChange(e);
                                            this.hadleMfLogicChange(e);
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select"
                                            defaultValue
                                          />
                                          <option
                                            value="Marketing Fund Basis Rate"
                                            label="Marketing Fund Basis Rate"
                                          />
                                          <option
                                            value="Marketing Fund Basis Pure Revenue Share"
                                            label="Marketing Fund Basis Pure Revenue Share"
                                          />
                                          <option
                                            value="Marketing Fund Basis Pure Revenue Share Sales Range"
                                            label="Marketing Fund Basis Pure Revenue Share Sales Range"
                                          />
                                          <option
                                            value="Marketing Fund Basis % of Rent"
                                            label="Marketing Fund Basis % of Rent"
                                          />
                                          <option
                                            value="Marketing Fund Basis Vouchers"
                                            label="Marketing Fund Basis Vouchers"
                                          />
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}



                            {this.state.marketingFundBasisRate && (
                              <div className="marketingFundBasisRate">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="mfLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            readOnly={true}
                                            name="mfLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF UOM <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfUom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Mf UOM",
                                            values.mfLogic.mfUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.mfLogic.mfUom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.onArea"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.mfLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.period > 1 &&
                                    typeof this.state.marketingFundDetails[
                                      this.state.escalationIndex
                                    ].mfRate !== "undefined" &&
                                    this.state.marketingFundDetails[
                                      this.state.escalationIndex
                                    ].mfRate !== 0 && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              Escalation %
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="mfLogic.escalationPercent"
                                                disabled={
                                                  this.state.disableOnEdit
                                                }
                                                onBlur={(e) => {
                                                  this.calculateRentRate(
                                                    e,
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                              />
                                              {this.validator.message(
                                                "Escalation %",
                                                values.mfLogic.escalationPercent,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="mfLogic.mfRate"
                                            onBlur={(e) => {
                                              this.calculateEscalationPercent(
                                                e,
                                                values,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "MF Rate",
                                            values.mfLogic.mfRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Rate Term",
                                            values.mfLogic.mfRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Frequency",
                                            values.mfLogic.mfFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.mfLogic.mfDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}




                            {this.state.marketingFundBasisPureRevenueShare && (
                              <div className="marketingFundBasisPureRevenueShare">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            name="mfLogic.revenueShare"
                                            type="number"
                                          />
                                          {this.validator.message(
                                            "Revenue Share",
                                            values.mfLogic.revenueShare,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Rate Term",
                                            values.mfLogic.mfRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Frequency",
                                            values.mfLogic.mfFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.mfLogic.mfDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Capped
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfCapped"}
                                            onChange={(e) => {
                                              this.changeMfCapped(e);
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="yes" label="Yes" />
                                            <option value="no" label="No" />
                                          </Field>
                                          {this.validator.message(
                                            "MF Capped",
                                            values.mfLogic.mfCapped,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.showMfCapped && (
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Capped UOM
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.mfCappedUom"}
                                              onChange={(e) => {
                                                this.validator =
                                                  new SimpleReactValidator({
                                                    autoForceUpdate: this,
                                                  });
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Sq Ft"
                                                label="Per Sq Ft"
                                              />
                                              <option
                                                value="Flat Amount"
                                                label="Flat Amount"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped Uom",
                                              values.mfLogic.mfCappedUom,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {values.mfLogic.mfCappedUom ==
                                      "Per Sq Ft" && (
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                MF Capped on Area
                                                <span className="astrik">*</span>
                                              </label>
                                              <div className="col-sm-7">
                                                <Field
                                                  as="select"
                                                  name={"mfLogic.mfCappedOnArea"}
                                                  onChange={(e) => {
                                                    handleChange(e);
                                                  }}
                                                >
                                                  <option
                                                    value=""
                                                    label="Select"
                                                    defaultValue
                                                  />
                                                  <option
                                                    value="Usable Area"
                                                    label="Usable Area"
                                                  />
                                                  <option
                                                    value="Carpet Area"
                                                    label="Carpet Area"
                                                  />
                                                  <option
                                                    value="Gross Leasable Area"
                                                    label="Gross Leasable Area"
                                                  />
                                                </Field>
                                                {this.validator.message(
                                                  "MF Capped on Area",
                                                  values.mfLogic.mfCappedOnArea,
                                                  "required",
                                                  { className: "text-danger" }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Capped Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="number"
                                              name="mfLogic.mfCappedRate"
                                            />
                                            {this.validator.message(
                                              "MF Capped Rate",
                                              values.mfLogic.mfCappedRate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Capped Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.mfCappedRateTerm"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Daily"
                                                label="Daily"
                                              />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped Rate Term",
                                              values.mfLogic.mfCappedRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}


                            {this.state
                              .marketingFundBasisPureRevenueShareSalesRange && (
                                <div className="marketingFundBasisPureRevenueShareSalesRange">
                                  <div className="row m-0">
                                    <div className="col-lg-12 p-0">
                                      <div className="inputContainer col-lg-12 col-md-12 p-0">
                                        <div className="gridColOneByThree textWithHrTag bigFonrSize">
                                          <h4>Revenue Share (%)</h4>
                                          <hr className="m-0" />
                                        </div>
                                        <div className="tableContainer p-0">
                                          <div className="col-lg-6 mb-4 p-0">
                                            <div className="inputContainer col-lg-12 col-md-12 p-0">
                                              <div className="row m-0">
                                                <label className="col-sm-3 ps-0 col-form-label">
                                                  No. of SLABS{" "}
                                                  <span className="astrik">
                                                    *
                                                  </span>
                                                </label>
                                                <div className="col-sm-7 pe-0">
                                                  <Field
                                                    type="text"
                                                    name="mfLogic.slabNumber"
                                                    value={
                                                      this.state.initialValues
                                                        .totalSlabs
                                                    }
                                                    className="slabInput"
                                                    onChange={(e) => {
                                                      this.addSlabRow(e);
                                                      handleChange(e);
                                                    }}
                                                  />
                                                  <ErrorMessage
                                                    name="mfLogic.slabNumber"
                                                    component="div"
                                                    className="text-red"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <table className="table tableSimple">
                                            <thead>
                                              <tr>
                                                <th scope="col">SLAB</th>
                                                <th scope="col">FROM</th>
                                                <th scope="col">To</th>
                                                <th scope="col">
                                                  MF Revenue Share (%)
                                                </th>
                                                <th scope="col" colSpan="">
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {this.state.initialValues.mfLogic
                                                .slabs.length > 0 &&
                                                this.state.initialValues.mfLogic.slabs.map(
                                                  (friend, index) => (
                                                    <tr key={index}>
                                                      <td>{index + 1}</td>
                                                      <td>
                                                        <Field
                                                          type="text"
                                                          name={`mfLogic.slabs.${index}.from`}
                                                          onChange={(e) => {
                                                            this.state.initialValues.mfLogic.slabs[
                                                              index
                                                            ].from =
                                                              e.target.value;
                                                            handleChange(e);
                                                          }}
                                                          value={
                                                            this.state
                                                              .initialValues
                                                              .mfLogic.slabs[
                                                              index
                                                            ].from
                                                          }
                                                        />
                                                      </td>
                                                      <td>
                                                        <Field
                                                          type="text"
                                                          name={`mfLogic.slabs.${index}.to`}
                                                          onChange={(e) => {
                                                            this.state.initialValues.mfLogic.slabs[
                                                              index
                                                            ].to =
                                                              e.target.value;
                                                            handleChange(e);
                                                          }}
                                                          value={
                                                            this.state
                                                              .initialValues
                                                              .mfLogic.slabs[
                                                              index
                                                            ].to
                                                          }
                                                          onBlur={(e) => {
                                                            if (
                                                              index <
                                                              this.state
                                                                .initialValues
                                                                .mfLogic.slabs
                                                                .length -
                                                              1
                                                            ) {
                                                              this.getFromForNextSlab(
                                                                e,
                                                                values,
                                                                index
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <Field
                                                          type="text"
                                                          name={`mfLogic.slabs.${index}.percent`}
                                                        />
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionAdd"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPlus}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionEdit"
                                                          href="#"
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faPen}
                                                          />
                                                        </a>
                                                      </td>
                                                      <td>
                                                        <a
                                                          className="actionDelete"
                                                          href="#"
                                                          onClick={(e) => {
                                                            this.state
                                                              .initialValues
                                                              .totalSlabs--;
                                                            var _slabs =
                                                              this.state
                                                                .initialValues
                                                                .mfLogic.slabs;
                                                            _slabs.splice(
                                                              index,
                                                              1
                                                            );
                                                            this.setState({
                                                              slabs: _slabs,
                                                            });
                                                          }}
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTimes}
                                                          />
                                                        </a>
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              name="mfLogic.fromDate"
                                              value={this.state.fromDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "From",
                                              this.state.fromDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              type="date"
                                              name="mfLogic.toDate"
                                              value={this.state.toDate}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            />
                                            {this.validator.message(
                                              "To",
                                              this.state.toDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.mfRateTerm"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Per Month"
                                                label="Per Month"
                                              />
                                              <option
                                                value="Per Quarter"
                                                label="Per Quarter"
                                              />
                                              <option
                                                value="Per Half Year"
                                                label="Per Half Year"
                                              />
                                              <option
                                                value="Per Year"
                                                label="Per Year"
                                              />
                                              <option
                                                value="Per Day"
                                                label="Per Day"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "MF Rate Term",
                                              values.mfLogic.mfRateTerm,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Frequency
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.mfFrequency"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="Daily" label="Daily" />
                                              <option
                                                value="Monthly"
                                                label="Monthly"
                                              />
                                              <option
                                                value="Quarterly"
                                                label="Quarterly"
                                              />
                                              <option
                                                value="Half Yearly"
                                                label="Half Yearly"
                                              />
                                              <option
                                                value="Yearly"
                                                label="Yearly"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "MF Frequency",
                                              values.mfLogic.mfFrequency,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Due Date{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-3 dueDateFieldWidth">
                                            <Field
                                              type="number"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="mfLogic.mfDueDate"
                                            ></Field>
                                          </div>
                                          <div className="col-sm-3 dueDateFieldWidth">
                                            <Field
                                              as="select"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="mfLogic.mfDueType"
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="Date" label="Date" />
                                              <option value="Days" label="Days" />
                                              <option
                                                value="Working Day"
                                                label="Working Day"
                                              />
                                            </Field>
                                          </div>
                                          <div className="col-sm-7 offset-sm-4 mt-3">
                                            <Field
                                              as="select"
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                              name="mfLogic.mfDueFrequency"
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Every Month"
                                                label="Every Month"
                                              />
                                              <option
                                                value="Subsequent Month"
                                                label="Subsequent Month"
                                              />
                                              <option
                                                value="Subsequent Quarter"
                                                label="Subsequent Quarter"
                                              />
                                              <option
                                                value="Subsequent Half Year"
                                                label="Subsequent Half Year"
                                              />
                                              <option
                                                value="Subsequent Year"
                                                label="Subsequent Year"
                                              />
                                              <option
                                                value="Next Financial Year"
                                                label="Next Financial Year"
                                              />
                                            </Field>
                                          </div>
                                          <div className="col-sm-7 offset-sm-4">
                                            {this.validator.message(
                                              "Due Date",
                                              values.mfLogic.mfDueDate,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row m-0">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            MF Capped
                                            <span className="astrik">*</span>
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.mfCapped"}
                                              onChange={(e) => {
                                                this.changeMfCapped(e);
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option value="yes" label="Yes" />
                                              <option value="no" label="No" />
                                            </Field>
                                            {this.validator.message(
                                              "MF Capped",
                                              values.mfLogic.mfCapped,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.showMfCapped && (
                                    <div className="row m-0">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              MF Capped UOM
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                as="select"
                                                name={"mfLogic.mfCappedUom"}
                                                onChange={(e) => {
                                                  this.validator =
                                                    new SimpleReactValidator({
                                                      autoForceUpdate: this,
                                                    });
                                                  handleChange(e);
                                                }}
                                              >
                                                <option
                                                  value=""
                                                  label="Select"
                                                  defaultValue
                                                />
                                                <option
                                                  value="Per Sq Ft"
                                                  label="Per Sq Ft"
                                                />
                                                <option
                                                  value="Flat Amount"
                                                  label="Flat Amount"
                                                />
                                              </Field>
                                              {this.validator.message(
                                                "MF Capped Uom",
                                                values.mfLogic.mfCappedUom,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {values.mfLogic.mfCappedUom ==
                                        "Per Sq Ft" && (
                                          <div className="col-lg-6">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  MF Capped on Area
                                                  <span className="astrik">*</span>
                                                </label>
                                                <div className="col-sm-7">
                                                  <Field
                                                    as="select"
                                                    name={"mfLogic.mfCappedOnArea"}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                  >
                                                    <option
                                                      value=""
                                                      label="Select"
                                                      defaultValue
                                                    />
                                                    <option
                                                      value="Usable Area"
                                                      label="Usable Area"
                                                    />
                                                    <option
                                                      value="Carpet Area"
                                                      label="Carpet Area"
                                                    />
                                                    <option
                                                      value="Gross Leasable Area"
                                                      label="Gross Leasable Area"
                                                    />
                                                  </Field>
                                                  {this.validator.message(
                                                    "MF Capped on Area",
                                                    values.mfLogic.mfCappedOnArea,
                                                    "required",
                                                    { className: "text-danger" }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              MF Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                type="number"
                                                name="mfLogic.mfCappedRate"
                                              />
                                              {this.validator.message(
                                                "MF Capped Rate",
                                                values.mfLogic.mfCappedRate,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              MF Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <div className="col-sm-7">
                                              <Field
                                                as="select"
                                                name={"mfLogic.mfCappedRateTerm"}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                }}
                                              >
                                                <option
                                                  value=""
                                                  label="Select"
                                                  defaultValue
                                                />
                                                <option
                                                  value="Daily"
                                                  label="Daily"
                                                />
                                                <option
                                                  value="Monthly"
                                                  label="Monthly"
                                                />
                                                <option
                                                  value="Quarterly"
                                                  label="Quarterly"
                                                />
                                                <option
                                                  value="Half Yearly"
                                                  label="Half Yearly"
                                                />
                                                <option
                                                  value="Yearly"
                                                  label="Yearly"
                                                />
                                              </Field>
                                              {this.validator.message(
                                                "MF Capped Rate Term",
                                                values.mfLogic.mfCappedRateTerm,
                                                "required",
                                                { className: "text-danger" }
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}





                            {this.state.marketingFundBasisPercentofRent && (
                              <div className="marketingFundBasisPercentofRent">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent UOM
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfUom"}
                                            onChange={(e) => {
                                              this.validator =
                                                new SimpleReactValidator({
                                                  autoForceUpdate: this,
                                                });
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Sq Ft"
                                              label="Per Sq Ft"
                                            />
                                            <option
                                              value="Flat Amount"
                                              label="Flat Amount"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Mf UOM",
                                            values.mfLogic.mfUom,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {values.mfLogic.mfUom == "Per Sq Ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area
                                          </label>
                                          <div className="col-sm-7">
                                            <Field
                                              as="select"
                                              name={"mfLogic.onArea"}
                                              onChange={(e) => {
                                                handleChange(e);
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select"
                                                defaultValue
                                              />
                                              <option
                                                value="Usable Area"
                                                label="Usable Area"
                                              />
                                              <option
                                                value="Carpet Area"
                                                label="Carpet Area"
                                              />
                                              <option
                                                value="Gross Leasable Area"
                                                label="Gross Leasable Area"
                                              />
                                            </Field>
                                            {this.validator.message(
                                              "On Area",
                                              values.mfLogic.onArea,
                                              "required",
                                              { className: "text-danger" }
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Rent Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="mfLogic.rentRate"
                                          />
                                          {this.validator.message(
                                            "Rent Rate",
                                            values.mfLogic.rentRate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Percentage of Rent
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="mfLogic.percentageofRent"
                                          />
                                          {this.validator.message(
                                            "Percentage of Rent",
                                            values.mfLogic.percentageofRent,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Rate Term",
                                            values.mfLogic.mfRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Frequency",
                                            values.mfLogic.mfFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.mfLogic.mfDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {this.state.marketingFundBasisVouchers && (
                              <div className="marketingFundBasisVouchers">
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.fromDate"
                                            value={this.state.fromDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "From",
                                            this.state.fromDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="date"
                                            name="mfLogic.toDate"
                                            value={this.state.toDate}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          />
                                          {this.validator.message(
                                            "To",
                                            this.state.toDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfRateTerm"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Per Month"
                                              label="Per Month"
                                            />
                                            <option
                                              value="Per Quarter"
                                              label="Per Quarter"
                                            />
                                            <option
                                              value="Per Half Year"
                                              label="Per Half Year"
                                            />
                                            <option
                                              value="Per Year"
                                              label="Per Year"
                                            />
                                            <option
                                              value="Per Day"
                                              label="Per Day"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Rate Term",
                                            values.mfLogic.mfRateTerm,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row m-0">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Type of Vouchers
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.voucherType"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="value" label="Value" />
                                            <option
                                              value="conditional"
                                              label="Conditional"
                                            />
                                            <option
                                              value="unconditional"
                                              label="Unconditional"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "Type of Vouchers",
                                            values.mfLogic.voucherType,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Amount Per Voucher{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="mfLogic.voucherAmount"
                                            onBlur={(e) => {
                                              this.calculateVoucherTotal(
                                                values,
                                                e,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "Voucher Amount",
                                            values.mfLogic.voucherAmount,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Voucher Count{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="text"
                                            name="mfLogic.voucherCount"
                                            onBlur={(e) => {
                                              this.calculateVoucherTotal(
                                                values,
                                                e,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                          {this.validator.message(
                                            "Count",
                                            values.mfLogic.voucherCount,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Total Amount of Vouchers{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            type="number"
                                            name="mfLogic.voucherTotalAmount"
                                            value={this.state.voucherTotalAmt}
                                            onChange={handleChange}
                                          />
                                          {this.validator.message(
                                            "Voucher Amount",
                                            this.state.voucherTotalAmt,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Frequency
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-7">
                                          <Field
                                            as="select"
                                            name={"mfLogic.mfFrequency"}
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Daily" label="Daily" />
                                            <option
                                              value="Monthly"
                                              label="Monthly"
                                            />
                                            <option
                                              value="Quarterly"
                                              label="Quarterly"
                                            />
                                            <option
                                              value="Half Yearly"
                                              label="Half Yearly"
                                            />
                                            <option
                                              value="Yearly"
                                              label="Yearly"
                                            />
                                          </Field>
                                          {this.validator.message(
                                            "MF Frequency",
                                            values.mfLogic.mfFrequency,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          MF Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            type="number"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueDate"
                                          ></Field>
                                        </div>
                                        <div className="col-sm-3 dueDateFieldWidth">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueType"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option value="Date" label="Date" />
                                            <option value="Days" label="Days" />
                                            <option
                                              value="Working Day"
                                              label="Working Day"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4 mt-3">
                                          <Field
                                            as="select"
                                            onChange={(e) => {
                                              handleChange(e);
                                            }}
                                            name="mfLogic.mfDueFrequency"
                                          >
                                            <option
                                              value=""
                                              label="Select"
                                              defaultValue
                                            />
                                            <option
                                              value="Every Month"
                                              label="Every Month"
                                            />
                                            <option
                                              value="Subsequent Month"
                                              label="Subsequent Month"
                                            />
                                            <option
                                              value="Subsequent Quarter"
                                              label="Subsequent Quarter"
                                            />
                                            <option
                                              value="Subsequent Half Year"
                                              label="Subsequent Half Year"
                                            />
                                            <option
                                              value="Subsequent Year"
                                              label="Subsequent Year"
                                            />
                                            <option
                                              value="Next Financial Year"
                                              label="Next Financial Year"
                                            />
                                          </Field>
                                        </div>
                                        <div className="col-sm-7 offset-sm-4">
                                          {this.validator.message(
                                            "Due Date",
                                            values.mfLogic.mfDueDate,
                                            "required",
                                            { className: "text-danger" }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {this.state.showAddBtn && (
                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button
                              className="add_button"
                              type="button"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.addMfDetails(
                                  values,
                                  resetForm,
                                  setFieldValue
                                );
                              }}
                            >
                              Add
                            </button>
                            <button
                              className="reset_button"
                              type="reset"
                              onClick={(e) => {
                                console.log(values, "nn");
                                this.resetMfDetails(values, resetForm);
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        )}
                        <span className="remarks">Notes/Remarks</span>
                        <Field as="textarea" className="notes mb-3" name="notes_8" />
                      </div>
                      {this.mainFormValidator.message(
                        "Marketing Fund Details",
                        this.countError,
                        "required",
                        { className: "text-danger" }
                      )}
                      <div className="tableContainer p-0">
                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Period</th>
                              <th scope="col">Period Term (YY-MM-DD)</th>
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">Marketing Fund Logic</th>
                              <th scope="col">Rate/ Flat Amount</th>
                              <th scope="col" colSpan="2">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.marketingFundDetails.map(function (
                              name,
                              index
                            ) {
                              return (
                                <tr key={"mfTable" + index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <a
                                      className="popupLink"
                                      onClick={(e) => {
                                        this.state.popupData = name;
                                        this.openModal();
                                      }}
                                    >
                                      {name.period}
                                    </a>
                                  </td>
                                  <td>
                                    {name.periodTermYY == ""
                                      ? "0"
                                      : name.periodTermYY}
                                    {"-"}
                                    {name.periodTermMM == ""
                                      ? "0"
                                      : name.periodTermMM}
                                    {"-"}
                                    {name.periodTermDD == ""
                                      ? "0"
                                      : name.periodTermDD}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.fromDate)}
                                  </td>
                                  <td>
                                    {leaseDateFormat(name.toDate)}
                                  </td>
                                  <td>{name.mfLogicText}</td>
                                  <td>
                                    {name.voucherAmount || name.mfRate || "-"}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="tableActionEdit rentalEdit"
                                      onClick={(e) => {
                                        this.editMf(index, values);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPen} />
                                    </button>
                                    {this.state.marketingFundDetails.length ==
                                      index + 1 && (
                                        <button
                                          type="button"
                                          className="actionDelete rentalDeleteButton"
                                          onClick={(e) => {
                                            // if (
                                            //   window.confirm(
                                            //     <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
                                            //   )
                                            // ) {
                                            //   var _mf =
                                            //     this.state.marketingFundDetails;
                                            //   _mf.splice(index, 1);
                                            //   console.log(_mf, "new array");
                                            //   this.setState({
                                            //     marketingFundDetails: _mf,
                                            //     showForm: true,
                                            //   });
                                            //   this.state.period--;
                                            //   if (
                                            //     this.state.marketingFundDetails
                                            //       .length > 0
                                            //   ) {
                                            //     this.setState({
                                            //       fromDate: getToDate(
                                            //         this.state
                                            //           .marketingFundDetails[
                                            //           this.state
                                            //             .marketingFundDetails
                                            //             .length - 1
                                            //         ].toDate,
                                            //         2,
                                            //         0,
                                            //         0
                                            //       ),
                                            //     });
                                            //   } else {
                                            //     this.setState({
                                            //       fromDate: values.from,
                                            //     });
                                            //   }
                                            // }
                                            this.handleReset()

                                            this.setState({
                                              delete: true,
                                              index_val: index,
                                              revalue: values.from,
                                            });
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                      )}
                                  </td>
                                </tr>
                              );
                            },
                              this)}
                          </tbody>
                        </table>
                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                          <button type="submit" className="add_button">
                            Save Draft
                          </button>
                          <button type="reset" className="reset_button">
                            <Link to="/createlease">
                              Cancel
                            </Link>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form> */}
                </>
              )}
            </Formik>
          </div>
        </div>
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="lg"
                className="documentModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <div className="container modalBreadCrumbs">
                      <div className="row m-0">
                        <div className="col-lg-12">
                          <ul>
                            <li>Marketing Fund</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isOpen && this.mfPopup(this.state.popupData)}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              <p className="areYouSureText">"Are you sure you want to delete this period?"</p>
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
      </div>
    );
  }

  mfPopup(mf) {
    console.log(mf);
    if (mf.mfLogicText === "Marketing Fund Basis Rate") {
      return this.mfBasisRatePopup(mf);
    } else if (mf.mfLogicText === "Marketing Fund Basis Pure Revenue Share") {
      return this.mfBasisRatePureRevenueSharePopup(mf);
    } else if (
      mf.mfLogicText === "Marketing Fund Basis Pure Revenue Share Sales Range"
    ) {
      return this.mfBasisRatePureRevenueShareSalesRangePopup(mf);
    } else if (mf.mfLogicText === "Marketing Fund Basis % of Rate") {
      return this.mfBasisPercentOfRentPopup(mf);
    } else if (mf.mfLogicText === "Marketing Fund Basis Vouchers") {
      return this.mfBasisVouchersPopup(mf);
    }
  }

  mfBasisRatePopup(mf) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.periodTermYY == "" ? "0" : mf.periodTermYY}
                  {"-"}
                  {mf.periodTermMM == "" ? "0" : mf.periodTermMM}
                  {"-"}
                  {mf.periodTermDD == "" ? "0" : mf.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Marketing Fund Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfUom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfRate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfDueDate}
                  {`-`}
                  {mf.mfDueType}
                  {`-`}
                  {mf.mfDueFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfCapped}</label>
              </div>
            </div>
          </div>
          {mf.mfCapped == "yes" && (
            <div className="mfCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  mfBasisRatePureRevenueSharePopup(mf) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.periodTermYY == "" ? "0" : mf.periodTermYY}
                  {"-"}
                  {mf.periodTermMM == "" ? "0" : mf.periodTermMM}
                  {"-"}
                  {mf.periodTermDD == "" ? "0" : mf.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Marketing Fund Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  MF Revenue Share (%) <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.revenueShare}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfDueDate}
                  {`-`}
                  {mf.mfDueType}
                  {`-`}
                  {mf.mfDueFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfCapped}</label>
              </div>
            </div>
          </div>
          {mf.mfCapped == "yes" && (
            <div className="mfCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  mfBasisRatePureRevenueShareSalesRangePopup(mf) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.periodTermYY == "" ? "0" : mf.periodTermYY}
                  {"-"}
                  {mf.periodTermMM == "" ? "0" : mf.periodTermMM}
                  {"-"}
                  {mf.periodTermDD == "" ? "0" : mf.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Marketing Fund Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">
                  Revenue Share (%)
                </label>
                <div className="col-sm-10 slabWidthDesktop">
                  <div className="tableContainer">
                    <table className="table tableSimple">
                      <thead>
                        <tr>
                          <th scope="col">SLAB</th>
                          <th scope="col">FROM</th>
                          <th scope="col">To</th>
                          <th scope="col">Revenue Share (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mf.slabs.length > 0 &&
                          mf.slabs.map((name, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{name.from}</td>
                              <td>{name.to}</td>
                              <td>{name.percent}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfDueDate}
                  {`-`}
                  {mf.mfDueType}
                  {`-`}
                  {mf.mfDueFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfCapped}</label>
              </div>
            </div>
          </div>
          {mf.mfCapped == "yes" && (
            <div className="mfCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  mfBasisPercentOfRentPopup(mf) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.periodTermYY == "" ? "0" : mf.periodTermYY}
                  {"-"}
                  {mf.periodTermMM == "" ? "0" : mf.periodTermMM}
                  {"-"}
                  {mf.periodTermDD == "" ? "0" : mf.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Marketing Fund Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf UOM <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfUom}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  On Area <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.onArea}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfRate}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Percentage of Rent <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.percentageofRent}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfDueDate}
                  {`-`}
                  {mf.mfDueType}
                  {`-`}
                  {mf.mfDueFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfCapped}</label>
              </div>
            </div>
          </div>
          {mf.mfCapped == "yes" && (
            <div className="mfCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  mfBasisVouchersPopup(mf) {
    return (
      <div className="container">
        <div className="row m-0">
          {/* <div className="col-12">
            <h4 className="popupHeading">Rent Only & Rent Minus Cam</h4>
          </div> */}
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.period}</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Period Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.periodTermYY == "" ? "0" : mf.periodTermYY}
                  {"-"}
                  {mf.periodTermMM == "" ? "0" : mf.periodTermMM}
                  {"-"}
                  {mf.periodTermDD == "" ? "0" : mf.periodTermDD}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Marketing Fund Logic <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfLogicText}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  From <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.fromDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  To <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {leaseDateFormat(mf.toDate)}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Rate Term <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfRateTerm}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Type of Vouchers <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.voucherType}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Amount Per Voucher <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.voucherAmount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Voucher Count <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.voucherCount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Voucher Total Amount <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.voucherTotalAmount}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Frequency <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfFrequency}
                </label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Due Date <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">
                  {mf.mfDueDate}
                  {`-`}
                  {mf.mfDueType}
                  {`-`}
                  {mf.mfDueFrequency}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-6">
            <div className="inputContainer col-lg-12 col-md-12">
              <div className="row mb-3">
                <label className="col-sm-4 col-form-label">
                  Mf Capped <span className="astrik">*</span>
                </label>
                <label className="col-sm-7 col-form-label">{mf.mfCapped}</label>
              </div>
            </div>
          </div>
          {mf.mfCapped == "yes" && (
            <div className="mfCapped row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped UOM <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedUom}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped on Area <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedOnArea}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRate}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Mf Capped Rate Term <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {mf.mfCappedRateTerm}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(MarketingFund);
